export default {
    "AppTitle":"Registro.it - Statistics",
    "wrongRequestPathTitle":"Wrong Request Path",
    "wrongRequestPath":" is a wrong request.",
    "SUCCEEDED": "SUCCEEDED",
    "FAILED": "FAILED",
    "WARNING": "WARNING",
    "date":"Date",
    "year":"Year",
    "italian":"Italian",
    "english":"English",
    "emptyChart":"No Data Available",
    "options":"Options",
    "noDrilldown": "not available",
    "filters":"Filters",
    "helpGuide":"Enable/disable a guide on the various items of the page",
    "loadingChart": "Loading Chart",


    "crescitaMensile": "Monthly Growth",
    "crescitaInizioAnno": "Growth from beginnig",
    "crescitaMensileEdu": "Monthly Growth for EDU.IT",
    "crescitaInizioAnnoEdu":"Growth from beginning for EDU.IT",
    "crescitaPrimoAnnoEdu":"Growth from beginning for EDU.IT",
    "crescitaAnno":"Growth for year",

    // Charts
    "chart.registeredDomainName":"Registered Domains",
    "chart.yearGrowthRate":"Yearly Growth Rate",
    "chart.registeredDomainNameEDU":"Registered Domains for EDU.IT",
    // Guide

    "dataTable.guide":"**Data Table**\n\n Representation of the data that make up the graph in the table. You can export data in *CSV* format from the *Export* menu",
    "filters.guide":"**Filters**\n\n For some graphs it is possible to apply filters that modify the values shown on the graph. Filters can be of various kinds depending on the type of graph, such as geographical restrictions (countries, areas, regions) or on the type of Registrant (italian/foreign) etc.. \n\nBy using the *Reset filters* link, you can return to the initial unfiltered values.",
    "domainTab.guide":"**Available statistics on domain names**\n\nThe viewable data on domain names are of two types:\n * **Growth**: to display the data relating to the growth in time of the number of .it domain names\n * **Operations**: statistics on the main domain name operations (registrations, cancellations, renewals, changes of Registrar, etc.)",
    "registrantTab.guide":"**Statistics available on Registrants data**\n\n Statistics viewable for Registrants are related to the most common domain name transactions (registrations, cancellations, renewals, etc.), but shown from the point of view of geographical location or type of Registrant.",
    "registrarTab.guide":"**Statistics available on Registrars data**\n\nData are shown from the point of view of the geographical location of Registrars and are of 3 types: \n * **Registrars**: to see data on the number of active Registrars\n * **Growth**: to view the number and percentage of domain names maintained by Registrars\n * **Operations**: for statistics on most common operations on domain names carried out by Registrars",
    "toolbar.export.guide":"**Exporting Graph Data**\n\n Exportation can occur in the following ways:\n\n1. **As Image (PNG)**: it allows you to export the displayed graph image in PNG format, choosing from three available sizes. \n\n2. **CSV text format**: exports data in text format *CSV* only if the graph data table view is available.",
    "generic.chart.guide":"**Graph** \n\nThe graphic representation of the data you chose may vary depending on user selections: line charts and histograms etc. can be displayed. \n\nIn all graphs, abscissa represents time, while ordinate represents the values that the selected operation takes over time. \n\nThe graph elements (usually in the histograms) are often *clickable* allowing a temporal *drilldown* to pass for example, from an yearly to monthly visualization, daily, up to, in some cases, a time detail. ",
    "mainmenu.guide":"**MAIN MENU** \n\nThe main menu allows you to select the data type. There are three options available:\n * **Domains**: statistics on domain name operations.\n* **Registrars**: statistics on domain name operations based on the Registrars geographical location.\n* **Registrants**: statistics on domain names operations based on geographical locations and Registrant type (italian/foreign).",
    "toolbar.drilldown.guide": "**Drilldown** \n\nIf the chart is *temporarily navigable* this field is the time detail level (year, month, day) achieved. \n\n Through the *drilldown* values you can move temporarily backwards compared to the selections made by clicking on the elements of the chart. \n\n Not all the graphs can be *temporarily navigated* and in this case the *drilldown* value **not available** will appear.",
    "toolbar.dataicon.guide":"**Table/Graph**\n\nAllows to display the data in tabular or graphical form alternatively. \n\n If the associated tabular data does not exist, the icon is inactive. ",
    "domain.summary.guide":"1. **Descrizione del grafico** \n 2. **Drilldown**\n 3. **Scelta Operazioni**\n 4. **Grafico**\n 5. **Opzioni Esportazione** \n 6. **Mostra/Nascondi Dati**",

    "domain.esporta.guide":"**Esportazione Dati Grafico**\n\nL'esporazione può avvenire nei seguenti modi:\n\n1. **Come Immagine (PNG)**: Viene generato l'immagine dei grafico visualizzato scegliendo tra tre dimensioni.\n\n 2. **CSV**: ",

    "domain.drilldown.guide":"Descrizione come funziona il drildown etc. ajksjkajsa sajksjaks sajskajsa sajkskas sajksakjs sakjskajsaksj sakjsak\n\n jsaksjkajs sjaksjak s\n\njaksaksjaksj",

    "domain.mostradati.guide":"Bla bla barbapapa",
    "languageSwitcher.guide":"**Language selector** \n Allows you to select the language (Italian or English) used in the statistics portal",

    // Box title
    "domain.charts":"Domains Charts",
    "registrar.charts":"Registrars Charts",
    "registrant.charts": "Registrants Charts",
    //
    "show.button.table": "Show Data Table",
    "hide.button.table": "Hide Data Table",


    // Export
    "image.small":"Small Image",
    "image.medium":"Medium Image",
    "image.large":"Large Image",

    // header
    "domains":"Domains",
    "registrars":"Registrars",
    "registrants":"Registrants",
    "home": "home",
    "url_home": "/",
    "faq": "faq",
    "stats": "stats",
    "search": "search",
    "url_faq": "faq",
    "url_search": "search",

    // Filtri
    "clearFilters":"Reset Filters",


    // footer
    "footer.aboutUs": "About Us",
    "footer.registering": "Registra il tuo .IT",
    "footer.registrars": "I registrar",
    "footer.press": "Sala Stampa",
    "footer.registryProjects": "Progetti Registro",
    "footer.docs": "Form & Docs",
    "footer.url_aboutUs": "chi-siamo",
    "footer.url_registering": "registra-tuo-it",
    "footer.url_registrars": "registrar",
    "footer.url_press": "sala-stampa",
    "footer.url_registryProjects": "progetti-del-registro-it",
    "footer.url_docs": "docs",

    "NOIDN":"Synchronous",
    "ASYNC":"Asynchronous",
    "IDN":".it IDN Domains",
    "DOMAINS.IDN": ".it IDN Domains",
    "DOMAINS": ".it Domains",
    "Sincrono": "Sincrono",
    "Asincrono": "Asincrono",
    "Synchronous":"Synchronous",
    "Asynchronous":"Asynchronous",
    "Domains.IDN": '.it IDN Domains',
    ".it Domains":".it Domains",
    ".it IDN Domains": ".it IDN Domains",
    "EDU.IT": "edu.it Domains",
    "edu.it Domains": "edu.it Domains",
    "EDU.IDN.IT": "IDN edu.it Domains",
    "IDN edu.it Domains": "IDN edu.it Domains",


    "italy": "Italy",
    "foreign": "Foreign",

    "africa":"Africa",
    "americas":"Americas",
    "antartica": "Antartica",
    "asia":"Asia",
    "eu-west":"West Europe",
    "eu-south":"South Europe",
    "eu-north":"North Europe",
    "eu-east":"East Europe",
    "oceania":"Oceania",
    "world": "Other",

    // Menu Tabs
    "tabs.registrants": "Registrants",
    "tabs.domains": "Domains",
    "tabs.registrars": "Registrars",

    // Registrars
    "tab.registrar.count": "Registrars",
    "tab.registrar.registration": "Registrations",
    "tab.registrar.domain":"Maintained",
    "tab.registrar.delete": "Cancellations",
    "tab.registrar.growth": "Growth",
    "tab.registrar.transfer": "Transfers",
    "subtab.registrar.transfer_in":"Transfers In",
    "subtab.registrar.transfer_out":"Tranfers Out",
    "tab.registrar.contract_transfer":"Contract Tranfers",
    "subtab.registrar.contract_transfer_in":"Contract Transfers In",
    "subtab.registrar.contract_transfer_out":"Contract Tranfers Out",


    // registrants
    "tab.registrant.registration":"Registrations",
    "tab.registrant.delete":"Cancellations",
    "tab.registrant.transfer":"Transfers",
    "tab.registrant.restore":"Restores",
    "tab.registrant.renewal":"Renewals",
    "subtab.registrant.transfer":"Transfers",
    "subtab.registrant.transferWithTrade":"Transfers With Trade",
    "subtab.registrant.transferTotal":"Total Transfers",



    // --> Domains

    "tab.domain.registration": "Registrations",
    "tab.domain.delete": "Cancellations",
    "tab.domain.transfer": "Transfers",
    "tab.domain.trade": "trades",
    "tab.domain.renewal": "Renewals",
    "tab.domain.restore": "Restores",
    "tab.domain.reassign":"Reassignments",
    "tab.domain.growth": "Growth",


    // -->Domains-->Tranfers
    "subtab.domain.transfer":"Transfers",
    "subtab.domain.transferWithTrade":"Tranfers With Trade",
    "subtab.domain.transferBulk":"Bulk Transfers",
    "subtab.domain.transferTotal":"Tranfers Total",

    // Titoli dei Grafici
    // REGISTRAR
    "registrar.registration.title": "Domains Registrations Chart",
    "registrar.registration.yLabel":"Registered Domains",
    "registrar.registration.description":"The graph shows the number of domain name registrations according to the type of Registrars (Italian/foreign) and their geographical location. By clicking on the individual columns, you can drill down and get the monthly detail.",

    "registrar.count.title": "Registrar Count Chart",
    "registrar.count.yLabel":"Number of Registrars",
    "registrar.count.description":"The graph shows the number of active Registrars in .it. The Registrars are divided between Italians and Foreigners, and a special filter allows you to view the concentration at a geographical level.",

    "registrar.domain.title": "Maintained Domains Chart",
    "registrar.domain.yLabel":"Maintained Domains",
    "registrar.domain.description":"The graph shows the monthly trend of the number of domain names maintained by the Registrars according to the type (italian/foreign) and their geographical location.",

    "registrar.delete.title": "Domains Deletions Chart",
    "registrar.delete.yLabel":"Deleted Domains",
    "registrar.delete.description":"The graph shows the number of domain name cancellations according to the type of Registrar (italian/foreign) and their geographical location. By clicking on the individual columns, you can drill down and get the monthly detail.",

    "registrar.transfer_in.title":"Transfers In Chart",
    "registrar.transfer_in.yLabel":"Transferred Domains (In)",
    "registrar.transfer_in.description":"The graph shows the number of transferred domain names and to which Registrars (italian/foreign) and their geographical location) the domain names have been transferred.",

    "registrar.transfer_out.title":"Transfers Out Chart",
    "registrar.transfer_out.yLabel":"Transferred Domains (Out)",
    "registrar.transfer_out.description":"The graph shows the number of transferred domain names and which Registrars (italian/foreign) and their geographical location) have transferred them.",

    "registrar.contract_transfer_in.title":"Contract Transfer In Chart",
    "registrar.contract_transfer_in.yLabel":"Transferred Domains (In)",
    "registrar.contract_transfer_in.description":"The graph shows the number of domain names transferred following a transfer of contract and to which Registrars (italian/foreign) and their geographical location) the domain names were transferred.",

    "registrar.contract_transfer_out.title":"Contract Transfer Out Chart",
    "registrar.contract_transfer_out.yLabel":"Transferred Domains (Out)",
    "registrar.contract_transfer_out.description":"The graph shows the number of domain names transferred following a transfer of contract and which Registrars (italian/foreign) and their geographical location) have transferred them.",

    "registrar.growth.title": "Registrar Growth Chart",
    "registrar.growth.yLabel":"Percentage Growth",
    "registrar.growth.description":"The graph shows the growth of Registrars. Thanks to special filters, it is possible to visualize the overall growth over the years, in a specific year, by type (italian/foreign) and by geographical area.",

    // REGISTRANT
    "registrant.registration.title":"Domains Registrations Chart",
    "registrant.registration.yLabel":"Registered Domains",
    "registrant.registration.description":"The graph shows the number of domain name registrations according to the type of Registrants (italian/foreign) and their geographical location. By clicking on the individual columns it is possible to drill down and get the detail at month, day and hour level.",

    "registrant.delete.title":"Domains Cancellations Chart",
    "registrant.delete.yLabel":"Deleted Domains",
    "registrant.delete.description":"The graph shows the number of domain name cancellations according to the type of Registrants (italian/foreign) and their geographical location. By clicking on the individual columns, it is possible to drill down and get the detail at month, day and hour level.",

    "registrant.transfer.title":"Domains Transfers Chart",
    "registrant.transfer.yLabel":"Transferred Domains",
    "registrant.transfer.description":"The graph shows the number of domain names transferred from one Registrar to another, depending on the type of Registrants (italian/foreign) and their geographical location. By clicking on the individual columns it is possible to drill down and get the detail at month, day and hour level.",

    "registrant.transferWithTrade.title":"Domains Transfers With Trade Chart",
    "registrant.transferWithTrade.yLabel":"Transferred Domains With Trade",
    "registrant.transferWithTrade.description":"The graph shows the number of domain names transferred from one Registrar to another with a contextual change of Registrant, depending on the type of Registrants (italian/foreign) and their geographical location. By clicking on the individual columns, it is possible to drill down and get the detail at month, day and hour level",

    "registrant.transferTotal.title":"Total Domains Transfers Chart",
    "registrant.transferTotal.yLabel":"Transferred Domains (Totals)",
    "registrant.transferTotal.description":"The graph shows the number of domain names transferred from one Registrar to another, depending on the type of Registrants and their geographical location. By clicking on the individual columns it is possible to drill down and get the detail at month, day and hour level.",

    "registrant.restore.title":"Restored Domains Chart",
    "registrant.restore.yLabel":"Restored Domains",
    "registrant.restore.description":"The graph shows the total number of domain names restored following a cancellation, depending on the type of Registrants (italian/foreign) and their geographical location. Includes transfer and transfer with change of Registrant transactions. By clicking on the individual columns it is possible to drill down and get the detail at month, day and hour level.",

    "registrant.renewal.title":"Domains Renewal Chart",
    "registrant.renewal.yLabel":"Renewed Domains",
    "registrant.renewal.description":"The graph shows the number of domain names renewed annually, depending on the type of Registrants (italian/foreign) and their geographical location. By clicking on the individual columns it is possible to drill down and get the detail at month, day and hour level.",

    // -->Registrants
    "tabs.registrants.registrations":"Registrazions",
    "tabs.registrants.cancellations": "Cancellations",
    "tabs.registrants.transfers":"Transfers",
    "tabs.registrants.renewals":"Renewals",
    "tabs.registrants.restores":"Restores",
    "tabs.registrants.growth":"Growth",


    // -->Registrars
    "tabs.registrars.registrar":"Registrar",
    "tabs.registrars.registrations":"Registrations",
    "tabs.registrars.cancellations":"Cancellations",
    "tabs.registrars.maintained":"Mainteined",

    "tabs.registrars.transfers":"Tranfers",

    "tabs.registrars.contractTransfers":"Contract Transfers",
    "tabs.registrars.growth":"Growth",


    // --> Registrars->transfers
    "tabs.registrars.transfers.registarOut": "Trasferimento in Uscita",
    "tabs.registrars.transfers.registarIn": "Trasferimento in Ingresso",

    // --> Registrats->contractTransfers
    "tabs.registrars.contractTransfers.transferOut": "Cessione in Uscita",
    "tabs.registrars.contractTransfers.transferIn": "Cessione in Ingresso",


    // Field
    "zone":"Zone",
    "area":"Area",
    "years": "Years",
    "tipology":"Tipology",
    "region": "Region",
    "registrantType": "Registrant Type",

    //
    "edu.all": '- All Domains -',
    "edu.no": ".it Domains",
    "edu.only": "edu.it Domains",

    // Area italiana
    "area.all": "- All Areas -",
    "area.italy.all": "- All Areas -",
    "area.foreign.all": "- All Areas -",
    "area.north":"North",
    "area.center":"Center",
    "area.south":"South",
    "area.nord":"North",
    "area.centro":"Center",
    "area.sud":"South",


    "centro": "Center",
    "nord": "North",
    "sud": "South",
    // Area Stranieri
    "area.africa": "Africa",
    "area.antartica": "Antartica",
    "area.americas": "Americas",
    "area.asia":  "Asia",
    "area.oceania": "Oceania",
    "area.eu-east":"East Europe",
    "area.eu-north": "North Europe",
    "area.eu-west": "West Europe",
    "area.eu-south": "South Europe",

    "registrant.0": "-- All Registrants --",
    "registrant.1": "Natural Persons",
    "registrant.2": "Companies",
    "registrant.3": "Freelance Workers/Professionals",
    "registrant.4": "Non Profit Organizations",
    "registrant.5": "Public Organizations",
    "registrant.6": "Other Subjects",
    "registrant.7": "Foreigners",


    // Regioni Italia
    "region.all":"-- All Regions --",




    // Nord

    "Emilia-Romagna":"Emilia Romagna",
    "Friuli-Venezia Giulia":"Friuli Venezia Giulia",
    "Liguria":"Liguria",
    "Lombardia":"Lombardia",
    "Piemonte":"Piemonte",
    "Trentino-Alto Adige":"Trentino Alto Adige",
    "Valle d'Aosta":"Valle d'Aosta",
    "Veneto":"Veneto",

    // Centro
    "Lazio": "Lazio",
    "Marche": "Marche",
    "Toscana": "Toscana",
    "Umbria": "Umbria",

    // Sud
    "Abruzzo":"Abruzzo",
    "Basilicata":"Basilicata",
    "Calabria":"Calabria",
    "Campania":"Campania",
    "Molise":"Molise",
    "Puglia":"Puglia",
    "Sardegna":"Sardegna",
    "Sicilia":"Sicilia",


    //// Province
    // Piemonte
    "Alessandria":"Alessandria",
    "Asti":"Asti",
    "Biella":"Biella",
    "Cuneo":"Cuneo",
    "Novara":"Novara",
    "Torino":"Torino",
    "Verbano-Cusio-Ossola":"Verbano Cusio Ossola",
    "Vercelli":"Vercelli",

    //Emilia Romagna
    "Bologna":"Bologna",
    "Ferrara":"Ferrara",
    "Forlì-Cesena":"Forlì Cesena",
    "Modena":"Modena",
    "Parma":"Parma",
    "Piacenza":"Piacenza",
    "Ravenna":"Ravenna",
    "Reggio Emilia":"Reggio Emilia",
    "Rimini":"Rimini",

    // Friuli-Venezia Giulia
    "Gorizia":"Gorizia",
    "Pordenone":"Pordenone",
    "Trieste":"Trieste",
    "Udine":"Udine",

    // Liguria
    "Genova":"Genova",
    "Imperia":"Imperia",
    "La Spezia":"La Spezia",
    "Savona":"Savona",

    // Lombardia

    "Bergamo":"Bergamo",
    "Brescia":"Brescia",
    "Como":"Como",
    "Cremona":"Cremona",
    "Lecco":"Lecco",
    "Lodi":"Lodi",
    "Mantova":"Mantova",
    "Milano":"Milano",
    "Monza e Della Brianza":"Monza e Della Brianza",
    "Pavia":"Pavia",
    "Sondrio":"Sondrio",
    "Varese":"Varese",

    // Trentino-Alto Adige
    "Bolzano/Bozen":"Bolzano/Bozen",
    "Trento":"Trento",

    // Valle d'Aosta
    "Valle d'Aosta/Vallée d'Aoste":"Valle d'Aosta/Vallée d'Aoste",

    // Veneto
    "Belluno":"Belluno",
    "Padova":"Padova",
    "Rovigo":"Rovigo",
    "Treviso":"Treviso",
    "Venezia":"Venezia",
    "Verona":"Verona",
    "Vicenza":"Vicenza",

    // Lazio
    "Frosinone":"Frosinone",
    "Latina":"Latina",
    "Rieti":"Rieti",
    "Roma":"Roma",
    "Viterbo":"Viterbo",

    // Marche
    "Ancona":"Ancona",
    "Ascoli Piceno":"Ascoli Piceno",
    "Fermo":"Fermo",
    "Macerata":"Macerata",
    "Pesaro Urbino":"Pesaro Urbino",

    // Toscana
    "Arezzo":"Arezzo",
    "Firenze":"Firenze",
    "Grosseto":"Grosseto",
    "Livorno":"Livorno",
    "Lucca":"Lucca",
    "Massa-Carrara":"Massa Carrara",
    "Pisa":"Pisa",
    "Pistoia":"Pistoia",
    "Prato":"Prato",
    "Siena":"Siena",

    // Umbria
    "Perugia":"Perugia",
    "Terni":"Terni",

    // Abruzzo
    "Chieti":"Chieti",
    "L'Aquila":"L'Aquila",
    "Pescara":"Pescara",
    "Teramo":"Teramo",

    // Basilicata
    "Matera":"Matera",
    "Potenza":"Potenza",

    // Calabria
    "Catanzaro":"Catanzaro",
    "Cosenza":"Cosenza",
    "Crotone":"Crotone",
    "Reggio Calabria":"Reggio Calabria",
    "Vibo Valentia":"Vibo Valentia",

    // Campania
    "Avellino":"Avellino",
    "Benevento":"Benevento",
    "Caserta":"Caserta",
    "Napoli":"Napoli",
    "Salerno":"Salerno",

    // Molise
    "Campobasso":"Campobasso",
    "Isernia":"Isernia",

    // Puglia
    "Bari":"Bari",
    "Barletta Andria Trani":"Barletta Andria Trani",
    "Brindisi":"Brindisi",
    "Foggia":"Foggia",
    "Lecce":"Lecce",
    "Taranto":"Taranto",

    // Sardegna
    "Cagliari":"Cagliari",
    "Carbonia-Iglesias":"Carbonia-Iglesias",
    "Medio Campidano":"Medio Campidano",
    "Nuoro":"Nuoro",
    "Ogliastra":"Ogliastra",
    "Olbia-Tempio":"Olbia-Tempio",
    "Oristano":"Oristano",
    "Sassari":"Sassari",

    // Sicilia
    "Agrigento":"Agrigento",
    "Caltanissetta":"Caltanissetta",
    "Catania":"Catania",
    "Enna":"Enna",
    "Messina":"Messina",
    "Palermo":"Palermo",
    "Ragusa":"Ragusa",
    "Siracusa":"Siracusa",
    "Trapani":"Trapani",










    // Foreign Countries

    "Afghanistan": "Afghanistan",
    "Aland Islands": "Aland Islands",
    "Albania":"Albania",
    "Algeria":"Algeria",
    "American Samoa":"American Samoa",
    "Andorra":"Andorra",
    "Angola":"Angola",
    "Anguilla":"Anguilla",
    "Antarctica":"Antarctica",
    "Antigua And Barbuda":"Antigua And Barbuda",
    "Argentina":"Argentina",
    "Armenia":"Armenia",
    "Aruba":"Aruba",
    "Australia":"Australia",
    "Austria":"Austria",
    "Azerbaijan":"Azerbaijan",
    "Bahamas":"Bahamas",
    "Bahrain":"Bahrain",
    "Bangladesh":"Bangladesh",
    "Barbados":"Barbados",
    "Belarus":"Belarus",
    "Belgium":"Belgio",
    "Belize":"Belize",
    "Benin":"Benin",
    "Bermuda":"Bermuda",
    "Bhutan":"Bhutan",
    "Bolivia":"Bolivia",
    "Bonaire, Sint Eustatius and Saba":"Bonaire, Sint Eustatius and Saba",
    "Bosnia And Herzegovina":"Bosnia And Herzegovina",
    "Botswana":"Botswana",
    "Bouvet Island":"Bouvet Island",
    "Brazil":"Brazil",
    "British Indian Ocean Territory":"British Indian Ocean Territory",
    "Brunei Darussalam":"Brunei Darussalam",
    "Bulgaria":"Bulgaria",
    "Burkina Faso":"Burkina Faso",
    "Burundi":"Burundi",
    "Cambodia":"Cambodia",
    "Cameroon":"Cameroon",
    "Canada":"Canada",
    "Cape Verde":"Capo Verde",
    "Cayman Islands":"Cayman Islands",
    "Central African Republic":"Central African Republic",
    "Chad":"Chad",
    "Chile":"Chile",
    "China":"China",
    "Christmas Island":"Christmas Island",
    "Cocos (keeling) Islands":"Cocos (keeling) Islands",
    "Colombia":"Colombia",
    "Comoros":"Comoros",
    "Congo":"Congo",
    "Congo, The Democratic Republic Of The":"Congo, The Democratic Republic Of The",
    "Cook Islands":"Cook Islands",
    "Costa Rica":"Costa Rica",
    "Cote D'Ivoire":"Cote D'Ivoire",
    "Croatia":"Croazia",
    "Cuba":"Cuba",
    "Curaçao":"Curaçao",
    "Cyprus":"Cyprus",
    "Czech Republic":"Czech Republic",
    "Denmark":"Denmark",
    "Djibouti":"Djibouti",
    "Dominica":"Dominica",
    "Dominican Republic":"Dominican Republic",
    "Ecuador":"Ecuador",
    "Egypt":"Egypt",
    "El Salvador":"El Salvador",
    "Equatorial Guinea":"Equatorial Guinea",
    "Eritrea":"Eritrea",
    "Estonia":"Estonia",
    "Ethiopia":"Ethiopia",
    "Falkland Islands (malvinas)":"Falkland Islands (malvinas)",
    "Faroe Islands":"Faroe Islands",
    "Fiji":"Fiji",
    "Finland":"Finland",
    "France":"France",
    "French Guiana":"French Guiana",
    "French Polynesia":"French Polynesia",
    "French Southern Territories":"French Southern Territories",
    "Gabon":"Gabon",
    "Gambia":"Gambia",
    "Georgia":"Georgia",
    "Germany":"Germany",
    "Ghana":"Ghana",
    "Gibraltar":"Gibraltar",
    "Greece":"Greece",
    "Greenland":"Greenland",
    "Grenada":"Grenada",
    "Guadeloupe":"Guadeloupe",
    "Guam":"Guam",
    "Guatemala":"Guatemala",
    "Guernsey":"Guernsey",
    "Guinea":"Guinea",
    "Guinea-bissau":"Guinea-Bissau",
    "Guyana":"Guyana",
    "Haiti":"Haiti",
    "Heard Island And Mcdonald Islands":"Heard Island And Mcdonald Islands",
    "Holy See (vatican City State)":"Holy See (vatican City State)",
    "Honduras":"Honduras",
    "Hong Kong":"Hong Kong",
    "Hungary":"Hungary",
    "Iceland":"Iceland",
    "India":"India",
    "Indonesia":"Indonesia",
    "Iran, Islamic Republic Of":"Iran, Islamic Republic Of",
    "Iraq":"Iraq",
    "Ireland":"Ireland",
    "Isle Of Man":"Isle Of Man",
    "Israel":"Israel",
    "Italy":"Italy",
    "Jamaica":"Jamaica",
    "Japan":"Japan",
    "Jersey":"Jersey",
    "Jordan":"Jordan",
    "Kazakhstan":"Kazakhstan",
    "Kenya":"Kenya",
    "Kiribati":"Kiribati",
    "Korea, Democratic People'S Republic Of":"Korea, Democratic People'S Republic Of",
    "Korea, Republic Of":"Korea, Republic Of",
    "Kuwait":"Kuwait",
    "Kyrgyzstan":"Kyrgyzstan",
    "Lao People'S Democratic Republic":"Lao People'S Democratic Republic",
    "Latvia":"Latvia",
    "Lebanon":"Lebanon",
    "Lesotho":"Lesotho",
    "Liberia":"Liberia",
    "Libyan Arab Jamahiriya":"Libyan Arab Jamahiriya",
    "Liechtenstein":"Liechtenstein",
    "Lithuania":"Lithuania",
    "Luxembourg":"Luxembourg",
    "Macao":"Macao",
    "Macedonia, The Former Yugoslav Republic Of":"Macedonia, The Former Yugoslav Republic Of",
    "Madagascar":"Madagascar",
    "Malawi":"Malawi",
    "Malaysia":"Malaysia",
    "Maldives":"Maldives",
    "Mali":"Mali",
    "Malta":"Malta",
    "Marshall Islands":"Marshall Islands",
    "Martinique":"Martinique",
    "Mauritania":"Mauritania",
    "Mauritius":"Mauritius",
    "Mayotte":"Mayotte",
    "Mexico":"Mexico",
    "Micronesia, Federated States Of":"Micronesia, Federated States Of",
    "Moldova, Republic Of":"Moldova, Republic Of",
    "Monaco":"Monaco",
    "Mongolia":"Mongolia",
    "Montserrat":"Montserrat",
    "Morocco":"Morocco",
    "Mozambique":"Mozambique",
    "Myanmar":"Myanmar",
    "Namibia":"Namibia",
    "Nauru":"Nauru",
    "Nepal":"Nepal",
    "Netherlands":"Netherlands",
    "Netherlands Antilles":"Netherlands Antilles",
    "New Caledonia":"New Caledonia",
    "New Zealand":"New Zealand",
    "Nicaragua":"Nicaragua",
    "Niger":"Niger",
    "Nigeria":"Nigeria",
    "Niue":"Niue",
    "Norfolk Island":"Norfolk Island",
    "Northern Mariana Islands":"Northern Mariana Islands",
    "Norway":"Norway",
    "Oman":"Oman",
    "Pakistan":"Pakistan",
    "Palau":"Palau",
    "Palestinian Territory, Occupied":"Palestinian Territory, Occupied",
    "Panama":"Panama",
    "Papua New Guinea":"Papua New Guinea",
    "Paraguay":"Paraguay",
    "Peru":"Peru",
    "Philippines":"Philippines",
    "Pitcairn":"Pitcairn",
    "Poland":"Poland",
    "Portugal":"Portugal",
    "Puerto Rico":"Puerto Rico",
    "Qatar":"Qatar",
    "Republic of Montenegro":"Republic of Montenegro",
    "Republic of Serbia":"Republic of Serbia",
    "Reunion":"Reunion",
    "Romania":"Romania",
    "Russian Federation":"Russian Federation",
    "Rwanda":"Rwanda",
    "Saint Barthélemy":"Saint Barthélemy",
    "Saint Helena":"Saint Helena",
    "Saint Kitts And Nevis":"Saint Kitts And Nevis",
    "Saint Lucia":"Saint Lucia",
    "Saint Martin":"Saint Martin",
    "Saint Pierre And Miquelon":"Saint Pierre And Miquelon",
    "Saint Vincent And The Grenadines":"Saint Vincent And The Grenadines",
    "Samoa":"Samoa",
    "San Marino":"San Marino",
    "Sao Tome And Principe":"São Tomé e Príncipe",
    "Saudi Arabia":"Saudi Arabia",
    "Senegal":"Senegal",
    "Serbia And Montenegro":"Serbia And Montenegro",
    "Seychelles":"Seychelles",
    "Sierra Leone":"Sierra Leone",
    "Singapore":"Singapore",
    "Sint Maarten":"Sint Maarten",
    "Slovakia":"Slovakia",
    "Slovenia":"Slovenia",
    "Solomon Islands":"Solomon Islands",
    "Somalia":"Somalia",
    "South Africa":"South Africa",
    "South Georgia And The South Sandwich Islands":"South Georgia And The South Sandwich Islands",
    "South Sudan":"South Sudan",
    "Spain":"Spain",
    "Sri Lanka":"Sri Lanka",
    "Sudan":"Sudan",
    "Suriname":"Suriname",
    "Svalbard And Jan Mayen":"Svalbard And Jan Mayen",
    "Swaziland":"Swaziland",
    "Sweden":"Sweden",
    "Switzerland":"Switzerland",
    "Syrian Arab Republic":"Syrian Arab Republic",
    "Taiwan, Province Of China":"Taiwan, Province Of China",
    "Tajikistan":"Tajikistan",
    "Tanzania, United Republic Of":"Tanzania, United Republic Of",
    "Thailand":"Thailand",
    "Timor-leste":"Timor-leste",
    "Togo":"Togo",
    "Tokelau":"Tokelau",
    "Tonga":"Tonga",
    "Trinidad And Tobago":"Trinidad And Tobago",
    "Tunisia":"Tunisia",
    "Turkey":"Turkey",
    "Turkmenistan":"Turkmenistan",
    "Turks And Caicos Islands":"Turks And Caicos Islands",
    "Tuvalu":"Tuvalu",
    "Uganda":"Uganda",
    "Ukraine":"Ukraine",
    "United Arab Emirates":"United Arab Emirates",
    "United Kingdom":"United Kingdom",
    "United States":"United States",
    "United States Minor Outlying Islands":"nited States Minor Outlying Islands",
    "Uruguay":"Uruguay",
    "Uzbekistan":"Uzbekistan",
    "Vanuatu":"Vanuatu",
    "Venezuela":"Venezuela",
    "Viet Nam":"Viet Nam",
    "Virgin Islands, British":"Virgin Islands, British",
    "Virgin Islands, U.s.":"Virgin Islands, U.s.",
    "Wallis And Futuna":"Wallis And Futuna",
    "Western Sahara":"Western Sahara",
    "Yemen":"Yemen",
    "Zambia":"Zambia",
    "Zimbabwe":"Zimbabwe",


    //Zone
    "zone.all": "-- All Zones --",
    "zone.italy":"Italians",
    "zone.foreign":"Foreigners",
    "zone.strangers":"Foreigners",
    "zone.europe-west":"West Europe",
    "zone.europe-east":"East Europe",
    "zone.europe-north":"North Europe",
    "zone.europe-south":"South Europe",
    "zone.america":"Americas",
    "zone.asia":"Asia",
    "zone.africa":"Africa",
    "zone.australia":"Australia",
    "zone.oceania":"Oceania",
    "zone.world":"Other",

    //Tipology
    "tipology.all":"- All Registrants -",
    "tipology.naturalPerson":"Natural Persons",
    "tipology.companies":"Companies",
    "tipology.freelance":"Freelance Workers/Professionals",
    "tipology.noprofitCo":"No Profit Organizations",
    "tipology.publicCo":"Public Organizations",
    "tipology.other":"Other Subjects",


    // Azioni Pannello

    "panel.action.print":"Print Chart",
    "panel.action.export":"Export",
    "panel.action.export.png":"Export Chart in PNG Format",
    "panel.action.export.svg":"Export Chart in SVG Format",
    "panel.action.chartsToTable":"Show Chart Data",
    "panel.action.export.csv": "Export Data in CSV Format",


    // Titoli Pannello
//  "drillDown.yearly": "tutti gli anni",
//  "drillDown.montly": "per mese per l'anno ",
    //"drillDown.daily": "per giorno per mese di ",
    //"drillDown.hourly": "per ora per il giorno ",



    // Messages



    "domain.growth.description":"<p> The graph shows the growth of .it domain names. There are two series: </p><ul><li><strong>Registered Domains</strong>, represented by a blue area graph (y axis on the left), that indicates the total number of domain names present in the Registry database at the end of each month. The growth rates concerning the previous month and the beginning of the year, are also shown, </li><li><strong>Growth Rate</strong>, represented by a red line graph (y axis on the right), that indicates the growth of domain names on an annual basis. </li></ul>",

    "domain.names.growth":"Domains Growth Chart",
    "domain.growth.title":"Domains Growth Chart",
    "domain.growth.xLabel": "XLABEL",
    "domain.growth.yLabel": "YLABEL",

    "domain.registration.title":"Domains Registrations Chart",
    "domain.registration.yLabel":"Registered Domains",
    "domain.registration.description":"The graph shows the number of domain names registered on an annual, monthly, daily and hourly basis. You can drill down by clicking on the individual columns.",

    "domain.transfer.title": "Domains Transfers Chart",
    "domain.transfer.yLabel":"Transferred Domains",
    "domain.transfer.description":"The graph shows the number of domain names transferred from one Registrar to another. By clicking on the individual columns it is possible to drill down and get the detail at month and day level.",

    "domain.transferBulk.title": "Domains Transfers With Bulk Chart",
    "domain.transferBulk.yLabel":"Transferred Domains With Bulk",
    "domain.transferBulk.description":"The graph shows the number of domain names transferred from one Registrar to another by means of a bulk-transfer operation. By clicking on the individual columns it is possible to drill down and get the detail at month and day level.",

    "domain.transferTotal.title":"Total Domains Transfers",
    "domain.transferTotal.yLabel":"Transferred Domains (Totals)",
    "domain.transferTotal.description":"The graph shows the total number of domain names transferred from one Registrar to another. Includes transfer, transfer with change of Registrant and bulk transactions. By clicking on the individual columns it is possible to drill down and get the detail at month and day level.",

    "domain.transferWithTrade.title":"Domains Transfers With Trade Chart",
    "domain.transferWithTrade.yLabel":"Tansferred Domains With Trade",
    "domain.transferWithTrade.description":"The graph shows the number of domain names transferred from one Registrar to another with a contextual change of Registrant. By clicking on the individual columns it is possible to drill down and get the detail at month and day level.",

    "domain.restore.title":"Restored Domains Chart",
    "domain.restore.yLabel":"Restored Domains",
    "domain.restore.description":"The graph shows the number of domain names for which a restore operation has been carried out following cancellation. By clicking on the individual columns it is possible to drill down and get the detail at month and day level.",

    "domain.delete.title":"Deleted Domains Chart",
    "domain.delete.yLabel": "Deleted Domains",
    "domain.delete.description":"The graph shows the number of deleted domain names on an annual, monthly, daily and hourly basis. You can drill down by clicking on the individual columns.",





    "domain.reassign.title":"Domains Reassignments Chart",
    "domain.reassign.yLabel":"Reassigned Domains",
    "domain.reassign.description":"The graph shows the number of domain name subjected to a challenge for which a reassignment procedure has been carried out. By clicking on the individual columns, you can drill down and get the detail at month level.",

    "domain.renewal.title":"Domains Renewal Chart",
    "domain.renewal.yLabel": "Renewed Domains",
    "domain.renewal.description":"The graph shows the number of annually renewed domain names. By clicking on the individual columns, you can drill down and get the detail at month and day level.",

    "select.allYears":"-- All Years --",

    "allYears":"All Years",
    "yearly":"Yearly",
    "monthly": "Monthly",
    "daily":"Daily",
    "hourly":"Hourly",

}



// WEBPACK FOOTER //
// ./src/i18n/en.js